// This JavaScript file is created by Cision for our insider module.
// This is the first version of this file so far.
// This should be combined with insiders.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.insiders = !cision.websolution.settings.insider ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.insider.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    var textsInsidersDescriptions = cision.websolution.texts[settings.uiLanguage].insidersDescriptions;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var renderTransactionsList = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your insiders access key.");
            return;
        }
        var url = generateUrl('InsiderTrade/' + accessKey + '/TransactionsList');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                startDate: settings.startDate,
                endDate: settings.endDate
            }
        })
            .done(function (rawData) {
                $.each(rawData.Transactions, function (idx, objTransaction) {
                    objTransaction.TransactionDateFormatted = moment(objTransaction.TransactionDate).locale(settings.uiLanguage).format(settings.dateFormat);
                    objTransaction.SecurityTypeDescription = textsInsidersDescriptions.securityTypes[objTransaction.SecurityTypeId];
                    objTransaction.TransactionTypeDescription = textsInsidersDescriptions.transactionTypes[objTransaction.TransactionTypeId];
                    objTransaction.PositionDescription = textsInsidersDescriptions.positionTypes[objTransaction.PositionId];
                    objTransaction.HolderTypeDescription = textsInsidersDescriptions.holderTypes[objTransaction.HolderTypeId];

                    if (objTransaction.HolderName) {
                        objTransaction.HolderTypeDescription += ' [' + objTransaction.HolderName + ']';
                    }
                });


                var compositeModel = $.extend(rawData, texts, settings);

                var renderedHtml = $("#tplInsiderTransactionsList").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-transactions").html(renderedHtml);

            })
            .fail(function () {
                console.log('Could not retrieve data');
            });
    };

    var renderToGraph = function (objChart, options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your insiders access key.");
            return;
        }
        var url = generateUrl('InsiderTrade/' + accessKey + '/TransactionsList');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            data: {
                startDate: settings.startDate,
                endDate: settings.endDate
            }
        })
            .done(function (rawData) {
                var pointsInsiders = [];
                $.each(rawData.Transactions, function (idx, objTransaction) {
                    objTransaction.TransactionDateFormatted = moment(objTransaction.TransactionDate).locale(settings.uiLanguage).format(settings.dateFormat);
                    objTransaction.DetailsLink = rawData.DetailsLink + objTransaction.InsiderName;
                    objTransaction.PlusMinus = (objTransaction.Quantity > 0 ? '+' : '');
                    objTransaction.TransactionTypeDescription = textsInsidersDescriptions.transactionTypes[objTransaction.TransactionTypeId];

                    pointsInsiders.push({
                        x: moment(objTransaction.TransactionDate).format('X') * 1000,
                        title: settings.insidersTitle,
                        text: objTransaction.InsiderName,
                        InsiderTransaction: objTransaction
                    });
                });

                var objInstrument = { UniqueKey: settings.graphUniqueKey };
                var objChartSeries = {
                    id: objInstrument.UniqueKey,
                    name: 'INSIDERS',
                    type: 'flags',
                    data: pointsInsiders,
                    visible: true,
                    color: settings.graphColor,

                    // Extra data
                    objOriginal: objInstrument
                };

                objChartSeries.tooltip = {
                    //shared: true,
                    useHTML: true,
                    //headerFormat: '<div><small>{point.key}</small></div><br/>',
                    pointFormat: '<strong>{point.InsiderTransaction.InsiderName}</strong><br/>' +
                        '{point.InsiderTransaction.PlusMinus}{point.InsiderTransaction.Quantity} st ({point.InsiderTransaction.TransactionTypeDescription})'
                };

                objChart.addSeries(objChartSeries);
            })
            .fail(function () {
                console.log('Could not retrieve insiders data');
            })
            .always(function () {

            });
    };

    return {
        
        renderTransactionsList: renderTransactionsList,
        renderToGraph: renderToGraph
    };
} (jQuery);